// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"327":"216f1d23","393":"dc1cd217","719":"86698b3b"}[chunkId] + ".chunk.css";
};